import React, { useState } from "react";
import List from '@mui/material/List';
import MenuButton from "../StyledComponents/MenuButton/MenuButton";
import { useNavigate } from "react-router-dom";
import { Divider, Box, Typography, IconButton } from "@mui/material";
import BugReportIcon from "@mui/icons-material/BugReport";
import featureFlags from "../../featureFlags.json";
import DiagnosticInfo from "./DiagnosticInfo.tsx";


const PATHS: string[] = [
  "/members",
  "/events",
  "/partnerships",
  "/news",
  "/speakers",
  "/guests",
  "/eventcategories",
  "/products"
]

const MENU_ITEMS: { id: number, title: string }[] = [
  {
    id: 0,
    title: "Members"
  },
  {
    id: 1,
    title: "Events"
  },
  {
    id: 2,
    title: "Partnerships"
  },
  {
    id: 3,
    title: "News"
  },
  {
    id: 4,
    title: "Speakers"
  },
  {
    id: 5,
    title: "Guests"
  }
]

const CONFIGURATION_ITEMS_BASE: { id: number, title: string }[] = [
  {
    id: 6,
    title: "Event Categories"
  },
  {
    id: 7,
    title: "Product List"
  }
];

const CONFIGURATION_ITEMS = CONFIGURATION_ITEMS_BASE.filter(
  (item) => item.title !== "Product List" || featureFlags.ProductsListEnabled
);


export default function LeftMenu() {

  const navigate = useNavigate()
  const [selectedIndex, setSelectedIndex] = useState<number>()
  const [diagnosticOpen, setDiagnosticOpen] = useState(false)

  const handleClick = (index: number) => {
    setSelectedIndex(index)
    navigate(PATHS[index])
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "calc(100vh - 64px)"
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <List
          disablePadding
          sx={{
            width: "100%"
          }}
        >
          {
            MENU_ITEMS.map((item) =>
              <MenuButton
                key={item.id}
                title={item.title}
                selected={selectedIndex === item.id}
                onClick={() => handleClick(item.id)}
              />
            )
          }

          <Divider
            sx={{
              marginTop: 2,
              marginBottom: 2
            }}
          />

          <Typography
            variant="body2"
            color="textPrimary"
            paddingLeft={2}
            marginBottom={1}
          >
            Configuration
          </Typography>

          {
            CONFIGURATION_ITEMS.map((item) =>
              <MenuButton
                key={item.id}
                title={item.title}
                selected={selectedIndex === item.id}
                onClick={() => handleClick(item.id)}
              />
            )
          }
        </List>
      </Box>

      <Box
        sx={{
          padding: 2,
          borderTop: 1,
          borderColor: "divider"
        }}
      >
        <IconButton
          onClick={() => setDiagnosticOpen(true)}
          size="small"
          title="Diagnostic Info"
          sx={{ color: "text.secondary" }}
        >
          <BugReportIcon fontSize="small" />
        </IconButton>
      </Box>

      <DiagnosticInfo open={diagnosticOpen} onClose={() => setDiagnosticOpen(false)} />
    </Box>
  )
}
